module.exports = __webpack_public_path__ + "img/79.b714d5d8.png";